import { OBJECTIVESPROJECTLIST_SUCCESS, OBJECTIVESPROJECTLIST_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const objectivesProjectListReducer = (state = initialState, action) => {
    switch (action.type) {
        case OBJECTIVESPROJECTLIST_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case OBJECTIVESPROJECTLIST_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: [],
            };
        default:
            break;
    }

    return state;
};

export default objectivesProjectListReducer;



